// @flow
import {NavLink as Link, Switch, Route} from "react-router-dom"
import {containers} from "@swarm2/core"
import AccountIcon from "material-ui/svg-icons/action/account-circle"
import CharacterIcon from "material-ui/svg-icons/file/folder-shared"
import Divider from "material-ui/Divider"
import DebugIcon from "react-icons/lib/fa/bug"
import OptionsIcon from "react-icons/lib/fa/cog"
// below could also be fa/sort-amount-asc
import RankingsIcon from "react-icons/lib/fa/flag-checkered"
import MyCharacterIcon from "react-icons/lib/fa/folder-open"
import MeatIcon from "react-icons/lib/fa/database"
import CombatIcon from "react-icons/lib/fa/crosshairs"
import AchievementsIcon from "react-icons/lib/fa/trophy"
import StatisticsIcon from "react-icons/lib/fa/line-chart"
import * as React from "react"
import * as Util from "../common"
import MaterialNavLayout from "./MaterialNavLayout"
import ErrorHandler from "./ErrorHandler"
import NavFeedback, {NavItem} from "./FreshdeskTicketButton"
import _ from "lodash"

const M = Util.intlMessages("view.NavLayout")

export const NavLink = (props: Object) => {
  const {name, to = "/" + props.name, exact = true, ...attrs} = props
  return (
    <NavItem
      name={name}
      containerElement={
        <Link activeClassName="navLinkActive" exact={exact} to={to} />
      }
      {...attrs}
    />
  )
}

export const AuthUsername = containers.nav.AuthUsername(props => {
  if (props.isError) return <Util.Error inline error={props} />
  return <span>{props.displayName}</span>
})

const AuthUserLink = () => (
  <NavLink name="user" to="/me" icon={<AccountIcon />}>
    <AuthUsername />
  </NavLink>
)
const AuthCharsLink = () => (
  <NavLink name="characters" to="/me/characters" icon={<MyCharacterIcon />}>
    <M id="characters" />
  </NavLink>
)

export const UserNavLinks = containers.nav.UserNavLinks(props => {
  if (props.isError) return <Util.Error inline error={props} />
  const {isDebug} = props
  return (
    <div>
      {isDebug
        ? [
            <NavLink key="debug" name="debug" icon={<DebugIcon />}>
              <M id="debug" />
            </NavLink>,
            <Divider key="div" />,
          ]
        : null}
      <AuthUserLink />
      <AuthCharsLink />
      <NavLink name="options" icon={<OptionsIcon />}>
        <M id="options" />
      </NavLink>
      <Divider />
      <NavLink name="rankings" icon={<RankingsIcon />}>
        <M id="rankings" />
      </NavLink>
      <NavFeedback />
    </div>
  )
})

export const AuthCharname = containers.nav.AuthCharname(props => {
  if (props.isError) return <Util.Error inline error={props} />
  const {displayName} = props
  return <span>{displayName}</span>
})

export const CharNavLinks = containers.nav.CharNavLinks(props => {
  // special-case error: fallback to UserNavLinks if the character's missing
  if (props.isEmpty && _.isEqual(props.emptyKeys, ["character"])) {
    return <UserNavLinks />
  }
  // handle other errors normally; loading spinner
  if (props.isError) return <Util.Error inline error={props} />
  const {isDebug, charId, match, charExists} = props
  if (!charExists) return <UserNavLinks {...props} />
  const root = "/p/" + charId
  return (
    <div>
      {isDebug
        ? [
            <NavLink
              key="debug"
              name="debug"
              to={root + "/debug"}
              icon={<DebugIcon />}
            >
              <M id="debug" />
            </NavLink>,
            <Divider key="div" />,
          ]
        : null}
      <AuthUserLink />
      <AuthCharsLink />
      <NavLink name="options" to={root + "/options"} icon={<OptionsIcon />}>
        <M id="options" />
      </NavLink>
      <Divider />
      <NavLink name="character" to={root} icon={<CharacterIcon />}>
        <AuthCharname match={match} />
      </NavLink>
      <NavLink
        name="units"
        to={root + "/units"}
        exact={false}
        icon={<MeatIcon />}
      >
        <M id="meat" />
      </NavLink>
      <NavLink
        hidden={!props.isCombatVisible}
        name="combat"
        to={root + "/combat"}
        icon={<CombatIcon />}
      >
        <M id="combat" />
      </NavLink>
      <NavLink
        name="achievements"
        to={root + "/achievements"}
        icon={<AchievementsIcon />}
      >
        <M id="achievements" />
      </NavLink>
      <NavLink
        name="statistics"
        to={root + "/statistics"}
        icon={<StatisticsIcon />}
      >
        <M id="statistics" />
      </NavLink>
      <Divider />
      <NavFeedback />
    </div>
  )
})

// Awkward component= functions pass along router and parent props
const NavLinks = props => (
  <Switch>
    <Route
      path="/p/:charId"
      render={ps => <CharNavLinks {...ps} {...props} />}
    />
    <Route render={ps => <UserNavLinks {...ps} {...props} />} />
  </Switch>
)

export default function NavLayout(props: Object) {
  return (
    <ErrorHandler>
      <MaterialNavLayout menuItems={NavLinks}>
        <ErrorHandler>{props.children}</ErrorHandler>
      </MaterialNavLayout>
    </ErrorHandler>
  )
}



// WEBPACK FOOTER //
// ./src/nav/NavLayout.js